/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { useState, useCallback, useEffect, useMemo } from 'react';

import { useQuery } from 'react-query';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useLedgerFilteredWallets } from '../../utilities/sharedHooks/ledgerWallets';
import { walletCurrenciesTypes } from './constants';
import { GET_WHITELIST_ADDRESSES, WALLETS_ALL } from './queries';
import { useLedgerAccount } from '../../utilities/sharedHooks/ledgerSDKHooks';

export const useUserWallets = () => {
  const { data: wallets, refetch, isLoading } = useLedgerFilteredWallets(WALLETS_ALL);
  const result = [{}, refetch, isLoading];
  if (wallets) {
    const walletsCoins = _.keyBy(
      wallets.filter(
        (c) =>
          c.wallet_type.toLowerCase() === walletCurrenciesTypes.CRYPTO ||
          c.wallet_type.toLowerCase() === walletCurrenciesTypes.FIAT ||
          c.wallet_type.toLowerCase() === walletCurrenciesTypes.INTERNAL
      ),
      'coin'
    );
    result[0] = walletsCoins;
  }

  return result;
};

export const useUserWalletsByWalletType = (walletsType) => {
  const { data: wallets, refetch } = useLedgerFilteredWallets(WALLETS_ALL);
  const result = [{}, refetch];
  if (wallets && walletsType) {
    const walletsCoins = _.keyBy(
      wallets.filter((c) => c.wallet_type === walletsType.toLowerCase()),
      'coin'
    );
    result[0] = walletsCoins;
  }

  return result;
};

export const useSelectedWalletType = () => {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const selectedWalletType = useMemo(
    () => params?.walletType || walletCurrenciesTypes.CRYPTO,
    [params?.walletType]
  );
  const setSelectedWalletType = useCallback(
    (walletType) =>
      history.replace({ pathname: location.pathname.replace(selectedWalletType, walletType) }),
    [history, location.pathname, selectedWalletType]
  );
  useEffect(() => {
    if (!Object.values(walletCurrenciesTypes).includes(selectedWalletType)) {
      setSelectedWalletType(walletCurrenciesTypes.CRYPTO);
    }
  }, [selectedWalletType, setSelectedWalletType]);
  return [selectedWalletType, setSelectedWalletType];
};

export const useLedgerNotWhitelistedAddresses = (wallet) => {
  const [ledgerAddresses, isLoading, ledgerError] = useLedgerAccount(wallet.coin, true);

  const { data: whitelistedAddresses } = useQuery([
    GET_WHITELIST_ADDRESSES,
    { coin_id: wallet.coin_id },
  ]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (whitelistedAddresses) {
      const _options = [];
      const currentLedgerWalletIds = whitelistedAddresses.map((item) => item.wallet_id);
      ledgerAddresses.forEach((ledgerWalletAddressObj) => {
        if (!currentLedgerWalletIds.includes(ledgerWalletAddressObj.id)) {
          _options.push(ledgerWalletAddressObj);
        }
      });
      setOptions(_options);
    }
  }, [ledgerAddresses, whitelistedAddresses]);

  return [options, isLoading, ledgerError];
};
